/**
 * @license
 * @copyright Copyright Motili Inc., 2023 All Rights Reserved
 */

import { theme } from './theme';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';
import { ThemeProvider } from 'styled-components';
import { pdfjs } from 'react-pdf';

import App from './App';
import store, { persistor } from './common/redux/store';
import ScrollToTop from './navigation/ScrollToTop';

import './index.css';

pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const container = document.getElementById('root');
if (container) {
    const root = createRoot(container);
    root.render(
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
                <Router>
                    <ScrollToTop />
                    <ThemeProvider theme={theme}>
                        <App />
                    </ThemeProvider>
                </Router>
            </PersistGate>
        </Provider>
    );
}
